import GenerateAPI from '../generate.js'

let config = {
    checkUnpay: {
        url: '/client/order/checkUnpay',
        apiType: 'check',
    },
    operate: {
        url: '/client/order/operate',
        apiType: 'check',
    },
    submit: {
        url: '/client/order/submit/data',
        apiType: 'check',
    },
    ticketUpdate: {
        url: '/base/title/save',
    },
    ticketList: {
        url: '/base/title/list',
    },
}

const apiPayConfirm = GenerateAPI.generate(config)

export default apiPayConfirm
